import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { fontUbuntuLight } from '../../utilities/utilities';

const Tooltip = (props) => {

  return (
    <Fragment>
      <TooltipTrigger 
        id="info-tooltip"
        type="button" 
        role="button" 
        aria-controls="info-tooltip" 
        onMouseEnter={props.handleMouseEnter} 
        onMouseLeave={props.handleMouseLeave} 
        onKeyPress={props.handleKeyPress}
        onTouchStart={props.handleTouchStart} 
        // onTouchEnd={props.handleTouchEnd} 
        >
          {props.icon}
      </TooltipTrigger>
      <TooltipContainer tooltipVisible={props.tooltipVisible} backgroundColor={props.backgroundColor} onMouseEnter={props.handleMouseEnter} onMouseLeave={props.handleMouseLeave} onTouchStart={props.handleTouchStart}>

          {
              props.companyLogo ?
                  <divWrapper><TooltipCompanyImage src={props.companyLogo} alt={props.companyLogoAlt} />
                  <CardMagnify>
                  <CardTop />
                  <CardMiddle>
                  00000000
                  </CardMiddle>
                  <CardBottom />
                  </CardMagnify></divWrapper>
              :
                  null
          }

        {props.message ?
            <TooltipCompanyMessage><h4>{props.messageTitle}</h4><p>{props.message}</p></TooltipCompanyMessage>
        : 
          null
        }
      </TooltipContainer>
    </Fragment>
  )
}

const TooltipTrigger = styled.button`
  padding: 0 0.5rem;
  background-color: transparent;
  border: 1px solid #ddd;
  border-left: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TooltipContainer = styled.div`
  border-radius: 0.5rem;
  padding: 0.25rem;
  z-index: 1;
  
  min-width: 236px;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-size: 12px;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : '#ffffff'};
  border: 2px solid #d1d1d1;

  display: block;
	position: absolute;
  top: 50%;
  right: 50%;
	transform: translate(100%, -50%) scale(0.75) rotate(0deg);
	transform-origin: bottom center;
	transition: 0.15s ease-in-out;
	opacity: 0;
  visibility: hidden;
	width: 100%;
	max-width: 100vw;
	pointer-events: none;
	z-index: 5;
  
  ${props => props.tooltipVisible && css`
    opacity: 1;
    visibility: visible;
		transform: translate(106%,-50%) scale(1) rotate(0deg);
		pointer-events: inherit;
  `}
  
  &:after, &:before {
    content: '';
		display: block;
		margin: 0 auto;
		width: 0;
		height: 0;

		position: absolute;
		bottom: 50%;
		left: 0;
		transform: translate(-100%, 50%);
  }

  &:after {
    border: 14px solid transparent;
		border-right: 14px solid ${props => props.backgroundColor ? props.backgroundColor : '#ffffff'};
  }

  &:before {
    border: 17px solid transparent;
		border-right: 17px solid #d1d1d1;
  } 

  @media (max-width: 868px) {
    ${ css`
      transform: translate(12%,-114%) scale(1) rotate(0deg);

      &:after, &:before {
        content: '';
        display: block;
        margin: 0 auto;
        width: 0;
        height: 0;
        position: absolute;
        bottom: 0;
        left: 88%;
        transform: translate(-50%, 100%);
      } 

      &:after {
        border: 14px solid transparent;
        border-top: 14px solid ${props => props.backgroundColor ? props.backgroundColor : '#ffffff'};
      }
      &:before {
        border: 17px solid transparent;
        border-top: 17px solid #d1d1d1;
      }
    `}
  }

`;

const TooltipCompanyImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
` 

const TooltipCompanyMessage = styled.p`
    padding: 0.75rem;
    
    & h4{
        padding: 0 0 10px 0;
    }
`

const CardMagnify = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 100px;
  height: 80px;
  width: 80px;
  overflow:hidden;
  position: absolute;
  right: -18px;
  top: -21px;
  box-shadow: 0px 1px 4px 2px #646665;

`;

const CardTop = styled.div`
  background-color: #003494;
  flex: 1 1 auto;
`;
const CardMiddle = styled.div`
  color:#000;
  background-color: #fff;
  padding: 0.25rem;
  text-align:center;
`;
const CardBottom = styled.div`
  background-color:#262424;
  flex: 1 1 auto;
`;

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/Form/Tooltip.js